export default __webpack_public_path__ + "static/media/lock.63a99ea0.svg";